<template>

<div class="container-fluid">
		<div class="row">
			<div class="col">
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Node Ecosystem Browser</h4>
					</div>
					<div class="card-body">
						<template v-if="homeNode">
							Here is the ecosystem tree, which shows the entire parent path, as well as all the sub-nodes of the "Home Node".
							In the future, there will be a more robust browser with search and filtering.
							<br><br>
							<ul v-if="nodeHierarchy">
								<node-tree-item class="item" :model="nodeHierarchy"></node-tree-item>
							</ul>
							<div v-if="!nodeHierarchy"><strong><em style="color: #e66;">... Loading Node Hierarchy ...</em></strong></div>
						</template>
						<template v-else>
							<strong style="color: #e66;">ERROR: Home Node NOT FOUND!</strong>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import NodeTreeItem from "@/components/utilities/NodeTreeItem";
import _ from "lodash";

export default {
	name: "ecosystem-view",
	props: [ ],
	data() {
		return {
			nodeHierarchy : null,
			nodeHierarchyTEST : {
				name: 'My Tree',
				children: [
					{ name: 'hello' },
					{ name: 'wat' },
					{
					name: 'child folder',
					children: [
						{
						name: 'child folder',
						children: [
							{ name: 'hello' },
							{ name: 'wat' }
						]
						},
						{ name: 'hello' },
						{ name: 'wat' },
						{
						name: 'child folder',
						children: [
							{ name: 'hello' },
							{ name: 'wat' }
						]
						}
					]
					}
				]
			}
		};
	},
	components: { NodeTreeItem },
	computed:
	{
		...mapGetters( "nodes", {
			getNode: "node", // map STATE projects/all to "projects" AS A FUNCTION, which requires the nodeId as input!
			homeNode: "homeNode",
			parentNode: "parent",	// FUNCTION
		}),
	},
	methods: {
		...mapActions( "nodes", {
			findNode: "findNode",
			getHomeNode: "getHomeNode",
			getParentNode: "getParentNode",
			getNodePath: "getNodePath",
			listChildNodes: "listChildNodes",
			listSubNodes: "listSubNodes",
		}),
		async updateNodeHierarchy( )
		{

		},
		async getSubNodes( node )
		{
			if( node.isHome )
			{
				let subNodes = _.cloneDeep( await this.listSubNodes( { fromNodeId : node.$id } ) );
				node.children = [];		// Reset the children of this HOME node.
				let subLookup = { [node.$id] : node.children };	// 
				
				for( let i=0; i < subNodes.length; i++ )
				{
					let n = subNodes[i];
					if( !Array.isArray( subLookup[n.$id] ) )
						subLookup[n.$id] = [];
					n.children = subLookup[n.$id];

					if( !Array.isArray( subLookup[n.parent] ) )
						subLookup[n.parent] = [];
					subLookup[n.parent].push( n );
				}
			}
			else
			{
				node.children = _.cloneDeep( await this.listChildNodes( { fromNodeId : node.$id } ) );
				for( let i=0; i < node.children.length; i++ )
				{
					try {
						await this.getSubNodes( node.children[i] );
						delete node.children[i]._unavailable;
					} catch( err ) {
						console.warn( "Node ["+ node.children[i].$id +"] is not accessible!" );
						node.children[i]._unavailable = true;
					}
				}
			}
		}
	},
	async created( )
	{
		await this.getHomeNode( { } );
		let nodePath = await this.getNodePath( { nocache : true /*, fromNodeId : "mongo_2"*/ } );
		let currentNode = _.cloneDeep( this.getNode( nodePath.shift( ) ) );
		let rootNode = currentNode;	// Root is... root :)
		
		while( nodePath.length > 0 )
		{
			let childNode = _.cloneDeep( this.getNode( nodePath.shift( ) ) );
			if( childNode )
				currentNode.children = [ childNode ];
			currentNode = childNode;
		}
		currentNode.isHome = true;
		//currentNode.children = _.cloneDeep( await this.listChildNodes( { fromNodeId : currentNode.$id } ) );
		await this.getSubNodes( currentNode );
		this.nodeHierarchy = rootNode;
	},
	async mounted( )
	{
		
	}
};
</script>

<style scoped>
.item {
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
ul {
  padding-left: 1em;
  line-height: 1.5em;
  list-style-type: dot;
}
</style>


// WEBPACK FOOTER //
// src/components/Ecosystem.vue